// extracted by mini-css-extract-plugin
export default {"title":"styles_title__R8IS+","title_text":"styles_title_text__nyPOr","title_hint":"styles_title_hint__uJFG7","title_length":"styles_title_length__cKUBA"};